import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { notification, Authentication } from "../services";

const INITIAL_STATE = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  subscribe: true,
  error: "",
  submitting: false
};

class SignUp extends Component {
  state = INITIAL_STATE;

  componentDidMount() {
    window.$("#su-firstName").focus();
  }

  onChangeText = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onChangeChecked = e => {
    this.setState({ [e.target.name]: e.target.checked });
  };

  onSubmit = async e => {
    e.preventDefault();
    this.setState({ submitting: true });
    let response = await Authentication.signup(this.state);
    if (response.status) {
      this.setState({ submitting: false });
      notification.success(
        "You've successfully registered. Please login to continue."
      );
      setTimeout(() => {
        window.location.href = "/";
      }, 3000);
    } else {
      let defaultMessage =
        "Unable to process the request. Please try again later";
      let message = "";
      try {
        message = response.err.response.data || defaultMessage;
      } catch (err) {
        message = defaultMessage;
      }
      this.setState({ submitting: false });
      notification.error(message);
    }
  };

  isInvalid = () =>
    this.state.submitting ||
    this.state.firstName === "" ||
    this.state.lastName === "" ||
    this.state.email === "" ||
    this.state.password === "";

  render() {
    const {
      firstName,
      lastName,
      email,
      password,
      subscribe,
      error
    } = this.state;
    const invalid = this.isInvalid();

    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-5 col-xl-4 my-5">
            <div className="text-center">
              <Link to={"/"}>
                <img
                  src="/assets/img/logo.png"
                  width="230"
                  alt="Photon Commerce logo"
                />
              </Link>
            </div>

            <p className="text-muted text-center mt-3 mb-5">
              Sign up for a new account
            </p>

            <form onSubmit={this.onSubmit}>
              <div className="form-group">
                <label>Name</label>

                <div className="row">
                  <div className="col-6">
                    <input
                      type="text"
                      id="su-firstName"
                      className="form-control"
                      name="firstName"
                      placeholder="First"
                      autoFocus="autofocus"
                      tabIndex={1}
                      value={firstName}
                      onChange={this.onChangeText}
                      disabled={this.state.submitting}
                    />
                  </div>
                  <div className="col-6">
                    <input
                      type="text"
                      className="form-control"
                      name="lastName"
                      placeholder="Last"
                      tabIndex={2}
                      value={lastName}
                      onChange={this.onChangeText}
                      disabled={this.state.submitting}
                    />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label>Work email</label>

                <input
                  type="email"
                  id="su-email"
                  className="form-control"
                  name="email"
                  placeholder="Ex: you@company.com"
                  tabIndex={3}
                  value={email}
                  onChange={this.onChangeText}
                  disabled={this.state.submitting}
                />
              </div>

              <div className="form-group">
                <label>Password</label>

                <div className="input-group input-group-merge">
                  <input
                    type="password"
                    className="form-control form-control-appended"
                    name="password"
                    placeholder="Enter your password"
                    tabIndex={4}
                    value={password}
                    onChange={this.onChangeText}
                    disabled={this.state.submitting}
                  />

                  <div className="input-group-append">
                    <span className="input-group-text">
                      <i className="fe fe-eye"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="subscribeSwitch"
                    name="subscribe"
                    checked={subscribe}
                    tabIndex={5}
                    onChange={this.onChangeChecked}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="subscribeSwitch"
                  >
                    Subscribe to daily e-mail digest of activity
                  </label>
                  <small className="text-muted">Highly recommended</small>
                </div>
              </div>

              {error && <p className="text-danger">{error.message}</p>}

              <button
                type="submit"
                className="btn btn-lg btn-block btn-primary mb-3"
                disabled={invalid}
              >
                {this.state.submitting ? "Signin Up..." : "Sign up"}
              </button>

              <div className="text-center">
                <small className="text-muted text-center">
                  Already have an account? <Link to={"/sign-in"}>Sign in</Link>.
                </small>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SignUp);
